import type { OfflineReport } from '../engine';
import { RESOURCES_BY_ID, formatDuration, formatNumber } from '../engine';
import { gameStore } from '../game/store';

interface OfflineModalProps {
  report: OfflineReport;
  notation: 'standard' | 'scientific';
}

export function OfflineModal({ report, notation }: OfflineModalProps) {
  const gains = Object.entries(report.gained)
    .filter(([, amount]) => Math.abs(amount) > 0.5)
    .sort((a, b) => Math.abs(b[1]) - Math.abs(a[1]));

  const wasCapped = report.cappedSeconds < report.elapsedSeconds - 1;

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h2>The fire was kept</h2>
        <p>
          You were away {formatDuration(report.elapsedSeconds)}.{' '}
          {wasCapped
            ? `The tribe carried on for ${formatDuration(
                report.cappedSeconds,
              )} of it before the trail went cold.`
            : 'The tribe worked through all of it.'}
        </p>

        {gains.length === 0 ? (
          <p className="empty-note">Nothing was gained. Put someone to work.</p>
        ) : (
          <ul className="gain-list">
            {gains.map(([resourceId, amount]) => (
              <li key={resourceId}>
                <span>{RESOURCES_BY_ID[resourceId]?.name ?? resourceId}</span>
                <span className="amount">
                  {amount > 0 ? '+' : ''}
                  {formatNumber(amount, notation)}
                </span>
              </li>
            ))}
          </ul>
        )}

        <div className="card-effects" style={{ marginTop: 12 }}>
          {Math.abs(report.populationChange) >= 1 ? (
            <span className="effect-chip">
              {report.populationChange > 0 ? '+' : ''}
              {Math.round(report.populationChange)} tribe
            </span>
          ) : null}
          {report.talesSeen > 0 ? (
            <span className="effect-chip">
              {report.talesSeen} {report.talesSeen === 1 ? 'tale' : 'tales'} told
            </span>
          ) : null}
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="btn primary"
            onClick={() => gameStore.dismissOfflineReport()}
          >
            Take up the work
          </button>
        </div>
      </div>
    </div>
  );
}
